import React, { Fragment, useEffect, useContext, ReactNode } from 'react';
import { AuthContext } from "../contexts/auth";


const UnAuthLayout = ({ children }) => {
  const { profile, token } = useContext(AuthContext);

  useEffect(() => {
    const reactTarget = document.getElementById('react-target');

    // Add the class when the component mounts
    if (reactTarget) {
      reactTarget.classList.add('app');
    }

    // Remove the class when the component unmounts
    return () => {
      if (reactTarget) {
        reactTarget.classList.remove('app');
      }
    };
  }, []);

  return (
    <Fragment>
      {children}
    </Fragment>
  );
};

export default UnAuthLayout;
